var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.itemTipUrl)?_c('div',{staticClass:"item-tip"},[_c('img',{attrs:{"src":_vm.itemTipUrl}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }